/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { CreateOutcomeSuggestionResponse, CreateOutcomeSuggestionVars } from '../openapi-types.gen.js';

export type { CreateOutcomeSuggestionResponse, CreateOutcomeSuggestionVars } from '../openapi-types.gen.js';

export const useCreateOutcomeSuggestion = createMutationHook<CreateOutcomeSuggestionVars, CreateOutcomeSuggestionResponse, unknown>({
  specName: 'useCreateOutcomeSuggestion',
  path: '/v1/markets/{pubkey}/outcome-suggestions',
  method: 'POST',
  resolveUrl: (vars: CreateOutcomeSuggestionVars) => `/v1/markets/${vars.pubkey}/outcome-suggestions`,
  buildBody: (vars: CreateOutcomeSuggestionVars) => ({ label: vars.label, ticker: vars.ticker, imageUrl: vars.imageUrl, imageQuery: vars.imageQuery, aiPrompt: vars.aiPrompt, generationMode: vars.generationMode, reason: vars.reason }),
  parseResponse: (raw: unknown): CreateOutcomeSuggestionResponse => raw as CreateOutcomeSuggestionResponse,
  optimistic: [{
    queryKey: ['markets', 'list'],
    apply: (prev: any, vars: CreateOutcomeSuggestionVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }],
  
  
});
